<template>
	<div class="cour">
		<div>
			<div class="tit">
				<el-row>
					<el-col :span="19">
						<div class="grid-blue">我的订单</div>
					</el-col>
					<el-col :span="5">
						<!-- <div class="grid-red"><i class="el-icon-warning"></i>温馨提示: 完成所有学时方可进入考试</div> -->
					</el-col>
				</el-row>
			</div>
			<div class="list" v-if="orderlist.length!=0">
				<div class="list-item" v-for="(item,index) in orderlist" :key="index">
					<div class="num">订单编号:{{item.order_no}}</div>
					<div class="tits">{{item.course.title}}</div>
					<el-row>
						<el-col :span="10">
							<div class="grid-content">支付时间:{{item.paytime_text}}</div>
						</el-col>
						<el-col :span="6">
							<div class="grid-content">支付金额:¥{{item.price}}</div>
						</el-col>
						<el-col :span="8">
							<div class="grid-content">支付方式:{{item.type_data_text}}</div>
						</el-col>
					</el-row>
				</div>
			</div>
			<Nodata v-else></Nodata>
		</div>

	</div>
</template>

<script>
	import Nodata from '@/components/Nodata.vue'
	export default {
		components: {
			Nodata
		},
		data() {
			return {
				orderlist: []
			}
		},
		created() {
			this.getmyorder()
		},
		methods: {
			//获取订单列表
			getmyorder() {
				this.$http({
						method: 'GET',
						url: '/order/myorder',
						headers: {
							requireAuth: true // 这里通过设置requireAuth为true来启用token检查
						},
					})
					.then(response => {
						console.log(response)
						if (response.code == 1) {
							this.orderlist = response.data
						} else {
							this.$message(response.msg);
						}

					})
					.catch(error => {
						console.log(error)
					})
			},
		}
	}
</script>

<style scoped>
	/deep/.el-tabs__item {
		font-size: 16px !important;
	}

	.el-button--medium.is-round {
		padding: 8px 20px !important;
	}

	ul {
		margin: 0 !important;
		padding: 0 !important;
	}

	.cour {
		width: 100%;
		overflow: hidden;
		/* height: calc(100vh - 333px); */
		min-height: calc(100vh - 333px);
		background: #FFFFFF;
		border: 1px solid rgba(0, 0, 0, 0.07);
		padding-bottom: 10px;
	}

	.cour .tit {
		width: 100%;
		height: 45px;
		line-height: 45px;
		background: #FFFFFF;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
		border-radius: 0px 0px 5px 5px;
	}

	.grid-blue {
		font-size: 18px;
		color: #1072DA;
		padding-left: 20px;
	}

	.grid-red {
		font-size: 16px;
		color: #FF0000;
	}

	.list {
		/* overflow-y: auto;
		height: calc(100vh - 388px); */
	}

	.list-item {
		width: 681px;
		height: 142px;
		background: #FFFFFF;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
		float: left;
		border-radius: 5px;
		margin: 14px 0 0 13px;
		overflow-x: hidden;
	}

	/* 滚动条整体 */
	.list::-webkit-scrollbar {
		height: 20px;
		width: 1px;
	}

	/* 两个滚动条交接处 -- x轴和y轴 */
	.list::-webkit-scrollbar-corner {
		background-color: transparent;
	}

	/* 滚动条滑块 */
	.list::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #535353;
	}

	/* 滚动条轨道 */
	.list::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
		background: #ededed;
	}

	.num {
		width: 100%;
		height: 45px;
		font-size: 16px;
		color: #959595;
		line-height: 45px;
		padding-left: 14px;
		background: #F3F3F3;
	}

	.tits {
		width: 100%;
		height: 55px;
		font-size: 18px;
		color: #000000;
		line-height: 55px;
		padding-left: 22px;
	}

	.grid-content {
		font-weight: 400;
		font-size: 16px;
		color: #2A2A2A;
		padding-left: 22px;
	}
</style>
